import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const LogoutTitle = styled.div`
  text-align: center;
  margin-top: ${pxToRem('50px')};
`;

export const LogoutText = styled.div`
  text-align: center;
  margin-top: ${pxToRem('50px')};
`;

export const LogoutButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem('60px')};
  gap: ${pxToRem('20px')};
`;
